module.exports = __webpack_public_path__ + "img/12_6.5de08208.png";